import React from 'react';

/**
 * Collapsible "Ready to Start Your Session?" setup guide banner.
 * Visibility condition is left to the parent (e.g. empty courts, host, courts tab).
 */
export default function SetupGuideBanner({ expanded, onToggle, children }) {
  return (
    <div className="mb-6 bg-info-light border border-border-medium rounded-lg overflow-hidden mx-3 sm:mx-4">
      <div
        className="p-4 cursor-pointer hover:bg-primary-light/40 transition-colors"
        onClick={onToggle}
      >
        <div className="flex items-center justify-between">
          <div className="flex items-start flex-1">
            <div className="flex-shrink-0">
              <svg className="h-6 w-6 text-info mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </div>
            <div className="ml-3 flex-1">
              <h3 className="text-lg font-semibold text-text-primary">
                Ready to Start Your Session?
              </h3>
            </div>
          </div>
          <button
            className="ml-4 flex-shrink-0 text-info hover:text-primary-dark transition-colors"
            onClick={(e) => {
              e.stopPropagation();
              onToggle();
            }}
            aria-label={expanded ? 'Collapse guide' : 'Expand guide'}
          >
            <svg
              className={`w-5 h-5 transition-transform duration-200 ${expanded ? 'rotate-180' : ''}`}
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
            </svg>
          </button>
        </div>
      </div>
        <div className={`transition-all duration-300 ease-in-out ${expanded ? 'max-h-[500px] opacity-100' : 'max-h-0 opacity-0'} overflow-hidden`}>
        <div className="px-4 pb-4 text-text-secondary space-y-2">
          {children}
        </div>
      </div>
    </div>
  );
}
